import {Button, Modal} from '@yandex-delivery/blocks'
import React, {useCallback} from 'react'

import {Divider} from 'src/shared/components/desktop'
import {i18n} from 'src/shared/config'

import {FilterItem} from './filter-item/FilterItem'
import {classes} from './FiltersSidePanel.classes'
import type {Props} from './types'

export function FiltersSidePanel(props: Props): React.ReactElement<Props> {
  const {onClose, onChange, filters, filteredItemsAmount, options} = props
  const updateFiltersHandler = useCallback(
    (name: string, value: unknown) => {
      onChange({
        ...filters,
        [name]: value === filters[name] ? undefined : value,
      })
    },
    [filters, onChange],
  )

  const resetFilters = useCallback(() => {
    onChange(undefined)
    onClose()
  }, [onChange, onClose])

  return (
    <Modal.SidePanel anchor="right" className={classes.container} onClose={resetFilters} opened>
      <Modal.Header className={classes.header} title={i18n('ndd.pickup_points.filter.title')} />
      <Modal.Body className={classes.body}>
        <Divider />
        {options.map((item, index) => (
          <FilterItem
            key={index}
            checked={filters[item.name] === true || filters[item.name] === item.value}
            label={item.label}
            name={item.name}
            onChange={updateFiltersHandler}
            value={item.value}
          />
        ))}
      </Modal.Body>
      <Modal.Footer>
        <Button onPress={onClose} variant="action" fullWidth>
          {i18n('ndd.pickup_points.filter.confirm', {
            placeholder: {
              amount: filteredItemsAmount,
            },
          })}
        </Button>
      </Modal.Footer>
    </Modal.SidePanel>
  )
}
